import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';

@Component({
  selector: 'review-save',
  templateUrl: './review-save.component.html',
  styleUrls: ['./review-save.component.css']
})
export class ReviewSaveComponent implements OnInit {

  @Input() soObj: SalesOrder;

  constructor(public _dataService: DataService) { 
    
  }

  ngOnInit() {

  }

  saveSo() {
    if (this.validateData() == true) {
      this._dataService.saveSalesOrder(this.soObj).subscribe(resp=>{

      })

    }

  }

  validateData(): boolean {
    return true;
  }

}
